module.exports = "/assets/data/029bbd74a179fae9242ec481c7968b2c-CV5.data.json";